import { getSchedulerDataServicesRepair, getSchedulerDataServicesInstall, getSchedulerDataServicesMaintenance } from "../services";
import { filteredServicesComponents } from "../filteredServicesComponent"
export function IndoorAirQuality() {

  let servicesStart = [
    {
      id: "Installation",
      label: <>Installation</>,
      remType: "estimate",
      data: [
        [
          {
            name: "Installation",
            question: "Installation",
            answers: [
              {
                id: "Air Purifier",
                label: <>Air Purifier</>,
                value: "Air Purifier",
                jobType: "Air Purifier",
                remType: "estimate"
              },
              {
                id: "Central Humidifier",
                label: <>Central Humidifier</>,
                value: "Central Humidifier",
                jobType: "Central Humidifier",
                remType: "estimate"
              },
              {
                id: "Install Ducts or Vents",
                label: <>Install Ducts or Vents</>,
                value: "Install Ducts or Vents",
                jobType: "Ducts & Vents",
                remType: "estimate"
              },
            ],
          },
        ],
      ],
    },
    {
      id: "Repair",
      label: <>Repair</>,
      remType: "repair",
      data: [
        [
          {
            name: "Repair",
            question: "Repair",
            answers: [
              {
                id: "Air Purifier",
                label: <>Air Purifier</>,
                value: "Air Purifier",
                jobType: "Air Purifier",
                remType: "repair"
              },
              {
                id: "Central Humidifier",
                label: <>Central Humidifier</>,
                value: "Central Humidifier",
                jobType: "Central Humidifier",
                remType: "repair"
              },
              {
                id: "Repair Ducts or Vents",
                label: <>Repair Ducts or Vents</>,
                value: "Repair Ducts or Vents",
                jobType: "Ducts & Vents",
                remType: "repair"
              },
            ],
          },
        ],
      ],
    },
    {
      id: "Maintenance",
      label: <>Maintenance</>,
      remType: "maintenance",
      data: [
        [
          {
            name: "Maintenance",
            question: "Maintenance",
            answers: [
              {
                id: "Duct Cleaning",
                label: <>Duct Cleaning</>,
                value: "Duct Cleaning",
                jobType: "Ducts & Vents",
                remType: "maintenance",
              },
              {
                id: "Air Purifier",
                label: <>Air Purifier</>,
                value: "Air Purifier",
                jobType: "Air Purifier",
                remType: "maintenance",
              },
              {
                id: "Central Humidifier",
                label: <>Central Humidifier</>,
                value: "Central Humidifier",
                jobType: "Central Humidifier",
                remType: "maintenance",
              },
            ],
          },
        ],
      ],
    },
  ];

  let response = []

  servicesStart.map((services) => {
    if (services.remType == "estimate") {
      let serviceArray = []
      serviceArray.push(services)
      response.push(filteredServicesComponents(serviceArray, getSchedulerDataServicesInstall)[0])
    } else if (services.remType == "repair") {
      let serviceArray = []
      serviceArray.push(services)
      response.push(filteredServicesComponents(serviceArray, getSchedulerDataServicesRepair)[0])
    } else if (services.remType == "maintenance") {
      let serviceArray = []
      serviceArray.push(services)
      response.push(filteredServicesComponents(serviceArray, getSchedulerDataServicesMaintenance)[0])
    }


  })
  return response
}